import apiBase from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import Measurement from 'src/models/measurement';

export const getAllMeasurements = async (status?: string): Promise<Measurement[]> =>
  new Promise((resolve, reject) => {
    const params = status ? { status } : {};
    apiBase.get(endpoints.measurements.getAll, { params }).then((response) => {
      resolve(response.data as Measurement[]);
    });
  });

export const getMeasurement = async (id: number | string): Promise<Measurement> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.measurements.get(id)).then((response) => {
      resolve(response.data as Measurement);
    });
  });

export const createMeasurement = async (measurement: any): Promise<Measurement> =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    const hasFile = measurement.image instanceof File;

    if (hasFile) {
      formData.append('image', measurement.image);
    }

    Object.keys(measurement).forEach((key) => {
      if (key === 'image') return;
      const value = measurement[key];
      if (value !== undefined && value !== null) {
        formData.append(key, value.toString());
      }
    });

    const payload = hasFile ? formData : measurement;
    apiBase
      .post(endpoints.measurements.create, payload)
      .then((response) => {
        resolve(response.data as Measurement);
      })
      .catch(reject);
  });

export const updateMeasurement = async (measurement: any): Promise<Measurement> =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    const hasFile = measurement.image instanceof File;

    if (hasFile) {
      formData.append('image', measurement.image);
      formData.append('_method', 'PUT');
    }

    Object.keys(measurement).forEach((key) => {
      if (key === 'image') return;
      const value = measurement[key];
      if (value !== undefined && value !== null) {
        formData.append(key, value.toString());
      }
    });

    const payload = hasFile ? formData : measurement;
    const apiMethod = hasFile ? apiBase.post : apiBase.put;

    apiMethod(endpoints.measurements.update(measurement.id), payload)
      .then((response) => {
        resolve(response.data as Measurement);
      })
      .catch(reject);
  });

export const closeMeasurement = async (id: number | string): Promise<Measurement> =>
  new Promise((resolve, reject) => {
    apiBase.post(endpoints.measurements.close(id)).then((response) => {
      resolve(response.data as Measurement);
    });
  });

export const deleteMeasurement = async (id: number | string): Promise<void> =>
  new Promise((resolve, reject) => {
    apiBase.delete(endpoints.measurements.delete(id)).then(() => {
      resolve();
    });
  });
